module.exports = __webpack_public_path__ + "img/leipzig.9c9e2daf.png";